import { Navigate, useLocation } from "react-router-dom";
import { useIsLoggedIn, useDynamicContext } from "@dynamic-labs/sdk-react-core";

import { Paths } from "../common/constants";
import Loader from "../components/loader/loader";
import { getAccessToken } from "../common/utils";

const PrivateRoute = ({ children }: any) => {
  const location = useLocation();
  const isLoggedIn = useIsLoggedIn();
  const { sdkHasLoaded } = useDynamicContext();

  if (!sdkHasLoaded) {
    return <Loader open={true} />;
  }

  if (!isLoggedIn || !getAccessToken()) {
    return <Navigate to={Paths.LOGIN} replace state={{ from: location }} />;
  }

  return children;
};

export default PrivateRoute;
